import React from 'react'
import "./Footer.scss";
import {SiInstagram} from "react-icons/si";
import {FaYoutube} from "react-icons/fa";
import {FaFacebook} from "react-icons/fa";
import {AiOutlineTwitter} from "react-icons/ai";

const Footer = () => {
    return (
        <>
            <div className="footer">

            <div className="one">
            <table>
  <tr>
    <th className="biggdo">A propos</th>
  </tr>
  <br/>
  <tr>
    <th>StudentBank</th>
  </tr>
  <tr>
    <th>Appli Mobile</th>
    
  </tr>
  
  <tr>
    <th>Nos Partenaires</th>
  </tr>
  
  
</table>
            </div>
            <div className="two">

            <table>
  <tr>
    <th className="biggdo">Espace</th>
  </tr>
  <br/>
  <tr>
    <th>Etudiants</th>
  </tr>
  <tr>
    <th>Etudiants étranger</th>
    
  </tr>
  
  <tr>
    <th>Professionel Immobilier</th>
  </tr>
  <tr>
    <th>Professionel Bancaire</th>
  </tr>
  <tr>
    <th>Associations & collectivité</th>
  </tr>
  <tr>
    <th>Presse</th>
  </tr>
  <tr>
    <th>Recrutement</th>
  </tr>
  
</table>

            </div>
            <div className="three">

            <table>
  <tr>
    <th className="biggdo">Professionels</th>
  </tr>
  <br/>
  <tr>
    <th>Assurance</th>
  </tr>
  <tr>
    <th>Immobilier</th>
    
  </tr>
  
  <tr>
    <th>Banque</th>
  </tr>
  <tr>
    <th>Contrats</th>
  </tr>
  
  
</table>


            </div>
            <div className="four">
            <table>
  <tr>
    <th className="biggdo">Informations Légales</th>
  </tr>
  <br/>
  <tr>
    <th>Mentions Légales</th>
  </tr>
  <tr>
    <th>Données Personelles</th>
    
  </tr>
  
  <tr>
    <th>Cookies</th>
  </tr>
  <tr>
    <th>Aide</th>
  </tr>
  <tr>
    <th>Crédits</th>
  </tr>
  
</table>
                
            </div>
            <div className="five">
            <table>
  <tr>
    <th className="biggdo">Restez en Contact</th>
  </tr>
  <br/>
  <tr>
   <div className="icons">
   <SiInstagram className="social"/>
   <FaYoutube className="social"/>
   <FaFacebook className="social"/>
   <AiOutlineTwitter className="social"/>
   </div>
  </tr>
  </table>
            </div>
            </div>
        </>
    )
}

export default Footer
